import { RegionAvailable } from '@shared/services/language/registry';

export const DEFAULT_CENTER: Readonly<Record<RegionAvailable, google.maps.LatLngLiteral>> = {
  FR: { lat: 46.494444, lng: 2.602778 },
  ES: { lat: 40.463667, lng: -3.74922 },
  BE: { lat: 50.641111, lng: 4.668056 },
};
